/* sugar:assets/product-spotlight.js@2.2.0 */
/*
  Product Spotlight (sections/product-spotlight.liquid).

  The panel's video ships with its file address in data-src, so the page downloads nothing for it
  on load. When the panel comes within 300px of the viewport the address is attached and the video
  plays, muted and looping; it pauses while it is off screen. Visitors who prefer reduced motion
  keep the still picture underneath and the file is never fetched.
*/
(function () {
  'use strict';
  if (window.customElements.get('sugar-product-spotlight')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SugarProductSpotlight extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video[data-src]');
      if (!this.video || reduce.matches || !('IntersectionObserver' in window)) return;
      var self = this;
      this.io = new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        if (entry.isIntersecting) self.play();
        else self.pause();
      }, { rootMargin: '300px 0px' });
      this.io.observe(this.video);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      this.io = null;
    }

    play() {
      var v = this.video;
      if (!v.getAttribute('src')) {
        v.setAttribute('src', v.getAttribute('data-src'));
        v.muted = true;
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    pause() {
      if (this.video.getAttribute('src')) this.video.pause();
    }
  }

  window.customElements.define('sugar-product-spotlight', SugarProductSpotlight);
})();
